<template>
    <div @click="close" v-if="value" class="treeSelectChildCon">
        <div class="treeSelectChild" :style="`top:${top + 42}px;left:${left}px;max-height:${height}px`">
            <div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

export default {
    data() {
        return {
            left:"",
            top:"",
            height:""
        };
    },
    props: {
        value: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        value() {
            this.getParent();
        }
    },
    methods: {
        // 移动dom节点
        move() {
            document.body.appendChild(this.$el);
        },
        // 获得父元素
        getParent() {
            let dom = this.$parent.$el;

            // 获得父元素距离网页顶部的距离
            let top = dom.offsetTop;
            let left = dom.offsetLeft;

            // 获得页面高度
            let docHegiht =  document.body.clientHeight 
            let height = docHegiht - top - 60

            this.top = top;
            this.left = left;
            this.height = height
        },
        close() {
            this.$emit("close");
        }
    },
    created() {},
    mounted() {
        let vm = this;

        this.move();

        this.$nextTick(() => {
            this.getParent();
        });
    }
};
</script>

<style lang="scss" scoped>
.treeSelectChildCon {
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
}
.treeSelectChild {
    position: absolute;
    z-index: 99;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px;
    min-width: 217px;
    overflow-x: hidden;
    overflow-y: auto;

    box-shadow: 0 0px 12px 0 rgba(0, 0, 0, 0.2);
}
.treeSelectChild::after {
    content: " ";
    border-width: 6px;

    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;

    top: -6px;
    margin-left: -6px;
    border-top-width: 0;
    border-bottom-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/vue/components/treeSelect/treeSelectChild.vue